import React, {useEffect} from "react";
import QRCode from "react-qr-code";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Styles from "./styles.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {
    getReceiveUsdtWallet,
    sendWalletAfterTransaction,
    setBuyRequestCancel, setBuyRequestConfirm, setBuyRequestConfirmSuccess,
    setMatrixBuyQrModalStatus
} from "../../store/cabinet/action";

import {useTonAddress, useTonConnectUI} from "@tonconnect/ui-react";
import { useNavigate } from "react-router-dom";
import {walletShorter} from "../../helpers/walletShorter";
import {useTranslation} from "react-i18next";

import copyIcon from '../../theme/assets/svg/ftf_modal_copy_icon.svg';
import {toast} from "react-toastify";
import CountdownTimer from "../_UI/countdownTimer";




const CabinetMatrixBuyQrModal = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userFriendlyAddress = useTonAddress();
    const [tonConnectUI] = useTonConnectUI();
    const { t } = useTranslation();

    const matrixBuyQrModalStatus = useSelector((store) => store.cabinet.matrixBuyQrModalStatus);
    const buyRequestStatus = useSelector((store) => store.cabinet.buyRequestStatus);
    const buyRequestConfirmStatus = useSelector((store) => store.cabinet.buyRequestConfirmStatus);



    const closeModal = () => {
        dispatch(setMatrixBuyQrModalStatus(false));
        dispatch(setBuyRequestConfirmSuccess(false));
    };

    const cancelBuyRequestHandler = () => {
      dispatch(setBuyRequestCancel(buyRequestStatus?.request?.uuid));
      closeModal();
      toast(t('Ваша заявка отменена!'));
    }

    const settingsHandler = () => {
        navigate("/settings");
        closeModal();
    };

    const warningContent = () => {
      if (!userFriendlyAddress){
          return (
              <div className={`${Styles.warning}`}>
                  <div className={`${Styles.warningWithoutWallet}`}>
                      {t('Ваш телеграм кошелёк не подключён')}!{" "}
                      <span onClick={settingsHandler}>{t('Настройки')}</span>
                  </div>
                  <div className={`${Styles.warningNote}`}>
                      {t('Используйте')} <span>{t('исключительно')}</span> {t('кошелёк, подключённый к вашему аккаунту, для отправки')}. <br/>
                      {t('На этот адрес можно отправлять только USDT')}!
                  </div>
              </div>
          )
      } else {
          return (
              <div className={`${Styles.warning}`}>
                  <div className={`${Styles.warningWithWallet}`}>
                      {t('Используйте')} <span className={`${Styles.upper}`}>{t('исключительно')}</span> {t('кошелёк, подключённый к вашему аккаунту, для отправки')}. {t('На этот адрес можно отправлять только USDT')}! <br/>
                      <span style={{color: '#FFFEFE'}}>{t('Ваш подключенный кошелёк')}:</span>
                      <span className={`${Styles.wallet}`}>{walletShorter(userFriendlyAddress)}</span>
                  </div>
              </div>
          )
      }
    }

    const formatValue = (value) => {
        if (isNaN(value)) return "";
        const rounded = Math.round(value * 100) / 100;
        return parseFloat(rounded.toFixed(2)).toString();
    };

    const transactionHandler = async () => {
        if (userFriendlyAddress) {
            // console.log(formatValue(Number(amount) * Number(tokenRate?.token_rate)), formatValue(Number(amount) * Number(tokenRate?.token_rate)) * 1000000000)
            const myTransaction = {
                validUntil: Math.floor(Date.now() / 1000) + 60, // 60 сек
                messages: [
                    {
                        address: buyRequestStatus?.request?.wallet,
                        amount: `${formatValue(Number(buyRequestStatus?.request?.amount)) * 1000000000}`,
                        // stateInit: "base64bocblahblahblah==" // при необходимости
                    },
                ],
            };

            try {
                const result = await tonConnectUI.sendTransaction(myTransaction);
                dispatch(sendWalletAfterTransaction(userFriendlyAddress));
                dispatch(setBuyRequestConfirm(buyRequestStatus?.request?.uuid));
                toast('Your funds have been sent successfully. Wait for the tokens!');
                closeModal();
                console.log("Общий результат транзакции:", result);
                console.log("BOC транзакции:", result.boc);
            } catch (error) {
                if (error.message.includes("User rejected")) {
                    console.log("Пользователь отменил подтверждение транзакции");
                } else {
                    console.error("Ошибка при отправке транзакции:", error);
                }
            }
        }
    };

    const statusHandler = (status) =>{
        switch (status){
            case 'create':
                return t('Ожидает оплаты');
            case 'confirmed':
                return t('Подтвержден');
            case 'pending':
                return t('Ожидает подтверждения');
            case 'canceled':
                return t('Отменен');
            case 'expired':
                return t('Время истекло');
            default:
                return 'Unknown';
        }
    }

    const timerHandler = () =>{
        cancelBuyRequestHandler();
    }
    
    useEffect(()=>{
        if (matrixBuyQrModalStatus){
            dispatch(getReceiveUsdtWallet());
        }
    },[dispatch, matrixBuyQrModalStatus])

    return (
        <Popup
            open={matrixBuyQrModalStatus}
            modal
            nested
            closeOnDocumentClick
            onClose={closeModal}
        >
            <div className={`${Styles.modalContainer}`}>
                <div
                    className={`${Styles.modalCloseBtn}`}
                    onClick={() => {
                        closeModal();
                    }}
                >
                    <div />
                    <div />
                </div>
                {buyRequestStatus ?
                    <div className={`${Styles.modalContentWrap}`}>
                        <div className={`${Styles.modalTitle}`}>{t('Купить токены')}</div>
                        <div className={`${Styles.addressWrap}`}>
                            <div className={`${Styles.addressBox}`}>
                                <div className={`${Styles.addressBoxTitle}`}>{t('Адресс')}</div>
                                <div className={`${Styles.address}`}>
                                    {buyRequestStatus?.request?.wallet ? walletShorter(buyRequestStatus?.request?.wallet) : 'Loading...'}
                                    <div
                                        className={`${Styles.addressCopyAbs}`}
                                        onClick={()=>{
                                            navigator.clipboard.writeText(buyRequestStatus?.request?.wallet);
                                            toast(t(`${t('Скопировано')}!`))
                                        }}
                                    >
                                        <img src={copyIcon} alt="copy address"/>
                                    </div>
                                </div>
                            </div>
                            {buyRequestStatus?.request?.wallet ?
                                <div className={`${Styles.qrBox}`}>
                                    <div className={`${Styles.detailsWrap}`}>
                                        <div className={`${Styles.detailsItem}`}>
                                            <div className={`${Styles.detailsItemName}`}>{t('Статус')}:</div>
                                            <div className={`${Styles.detailsItemValue}`}>
                                                {buyRequestConfirmStatus ? statusHandler('pending') : statusHandler(buyRequestStatus?.request?.status)}
                                            </div>
                                        </div>
                                        <div className={`${Styles.detailsItem}`}>
                                            <div className={`${Styles.detailsItemName}`}>
                                                <span className={`${Styles.detailsItemNameM}`}>{t('Время')}:</span>
                                                <span className={`${Styles.detailsItemNameD}`}>{t('Время на оплату')}:</span>
                                            </div>
                                            <div className={`${Styles.detailsItemValue}`}><CountdownTimer onComplete={timerHandler}/></div>
                                        </div>
                                        <div className={`${Styles.detailsItem}`}>
                                            <div className={`${Styles.detailsItemName}`}>{t('Сумма')}:</div>
                                            <div className={`${Styles.detailsItemValue}`}>{buyRequestStatus?.request?.amount} {buyRequestStatus?.request?.currency}</div>
                                        </div>
                                    </div>
                                    <div className={`${Styles.qr}`}>
                                        <QRCode
                                            size={256}
                                            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                            value={buyRequestStatus?.request?.wallet}
                                            viewBox={`0 0 256 256`}
                                        />
                                    </div>

                                </div> :
                                <div className={`${Styles.qrBox}`}>

                                </div>
                            }

                        </div>
                        {buyRequestStatus?.request?.currency === 'TON' && !buyRequestConfirmStatus ?
                            <div className={`${userFriendlyAddress ? Styles.ftfBorderBtn : Styles.ftfDisabledBtn} ${Styles.customMargin}`} onClick={transactionHandler}>
                                {t('Купить через TG')} (TON)
                            </div> : null
                        }

                        <div className={`${Styles.warningWrap}`}>
                            {warningContent()}
                        </div>
                        {/*<div className={`${Styles.detailsWrap}`}>*/}
                        {/*    <div className={`${Styles.detailsItem}`}>*/}
                        {/*        <div className={`${Styles.detailsItemName}`}>{t('Статус')}:</div>*/}
                        {/*        <div className={`${Styles.detailsItemValue}`}>{statusHandler(buyRequestStatus?.request?.status)}</div>*/}
                        {/*    </div>*/}
                        {/*    <div className={`${Styles.detailsItem}`}>*/}
                        {/*        <div className={`${Styles.detailsItemName}`}>{t('Время на оплату')}:</div>*/}
                        {/*        <div className={`${Styles.detailsItemValue}`}><CountdownTimer onComplete={timerHandler}/></div>*/}
                        {/*    </div>*/}
                        {/*    <div className={`${Styles.detailsItem}`}>*/}
                        {/*        <div className={`${Styles.detailsItemName}`}>{t('Сумма')}:</div>*/}
                        {/*        <div className={`${Styles.detailsItemValue}`}>{buyRequestStatus?.request?.amount} {buyRequestStatus?.request?.currency}</div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {buyRequestConfirmStatus ? null :
                            <div className={`${Styles.btnsWrap}`}>
                                <div className={`${Styles.btnsWrapItem}`} onClick={()=>{dispatch(setBuyRequestConfirm(buyRequestStatus?.request?.uuid))}}>{t('Я оплатил')}</div>
                                <div className={`${Styles.btnsWrapItem}`} onClick={()=>{cancelBuyRequestHandler()}}>{t('Отменить')}</div>
                            </div>
                        }

                        {/*{!userFriendlyAddress ? (*/}
                        {/*    <div className={`${Styles.buyNote}`}>*/}
                        {/*        Your telegram wallet is not connected!{" "}*/}
                        {/*        <span onClick={settingsHandler}>Settings</span>*/}
                        {/*    </div>*/}
                        {/*) : null}*/}
                    </div> :
                    <div className={`${Styles.modalContentWrapEmpty}`}>
                        Loading...
                    </div>
                }
            </div>
        </Popup>
    );
};

export default CabinetMatrixBuyQrModal;
